/*! Albatross (C) GrandPad, Inc */

import * as login_html from './login.html';
import Vue from 'vue';
import {Api} from './api';

export default Vue.extend({

	render: login_html.render,
	staticRenderFns: login_html.staticRenderFns,

	components: {
		'gpal-login-email': () => import('./ui/email'),
		'gpal-login-verify-email': () => import('./ui/verify_email'),
		'gpal-login-password': () => import('./ui/password')
	},

	props: {
		configEmail: {
			type: String,
			required: false
		}
	},

	data: function ()
	{
		return {
			step: 'email',
			email: null as string | null,
			error: null as string | null
		};
	},

	watch: {},

	created: function ()
	{
		if (this.configEmail !== null)
		{
			this.email = this.configEmail;
		}
	},

	methods: {

		handleBack ()
		{
			window.history.back();
		},

		onVerifyEmailBack ()
		{
			if (this.step === 'forgot_password')
			{
				this.step = 'password';
			}
			else
			{
				this.step = 'email';
			}
		},

		onPasswordBack ()
		{
			this.step = 'email';
		},

		onSubmitEmail (email: string)
		{
			this.error = null;
			Api.CheckLoginMethod({email})
				.then((result) =>
				{
					this.email = email;
					switch (result.method)
					{
						case 'email':
							this.step = 'verify_email';
							break;
						case 'password':
							this.step = 'password';
							break;
					}
				})
				.catch((error) =>
				{
					console.error(`Error checking login method: ${error}`);
					this.error = 'Error submitting email, please try again.'; // TODO:
				});
		},

		onResendEmail ()
		{
			this.error = null;
			if (this.email === null)
			{
				console.error('onResendEmail email is null');
				this.error = 'Error sending email, please try again.'; // TODO:
				return;
			}

			const emailFn = this.step == 'verify_email' ? Api.SendLoginEmail : Api.ForgotPassword;
			emailFn({email: this.email})
				.catch((error) =>
				{
					console.error(`Error resending login email: ${error}`);
					this.error = 'Error sending email, please try again.'; // TODO:
				});
		},

		onForgotPassword ()
		{
			this.error = null;
			if (this.email === null)
			{
				console.error('onForgotPassword email is null');
				this.error = 'Error sending forgot password email, please try again.'; // TODO:
				return;
			}
			Api.ForgotPassword({email: this.email})
				.then(() =>
				{
					this.step = 'forgot_password';
				})
				.catch((error) =>
				{
					console.error(`Error sending forgot password request: ${error}`);
					this.error = 'Error sending email, please try again.'; // TODO:
				});
		},

		onSubmitPassword (password: string)
		{
			this.error = null;
			if (this.email === null)
			{
				console.error('onSubmitPassword email is null');
				this.error = 'Error logging in, please try agian.'; // TODO:
				return;
			}
			Api.SubmitPassword({email: this.email, password})
				.then((result) =>
				{
					let urlParams = new URLSearchParams(window.location.search);
					let redirect = urlParams.get('redirect');
					if (redirect !== null && redirect.length > 0 && redirect[0] == '/')
					{
						window.location.href = redirect;
					}
					else
					{
						this.redirectToFlow();
					}
				})
				.catch((error) =>
				{
					console.error(`Error logging in: ${error}`);
					this.error = 'Error logging in, please try again.'; // TODO:
				});
		},

		redirectToFlow ()
		{
			window.location.href = '/flow';
		}
	}
});
